import { useState } from "react";
import { Box, Button } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import { keyframes } from "@mui/system";

// Animation Keyframes
const fadeScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export default function QRCode() {
  const [showQR, setShowQR] = useState(false);

  return (
    <Box
      sx={{
        width: 150,
        height: 150,
        backgroundColor: "white",
        boxShadow: 3,
        borderRadius: 2,
        padding: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        animation: `${fadeScale} 0.3s ease-in-out`,
      }}
    >
      <QRCodeCanvas value="https://your-website.com" size={120} />
    </Box>
  );
}
